// hooks/core/useNotificationActions.ts
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useNotificationActions() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleNotificationAction = (event: CustomEvent) => {
      const { action, payload } = event.detail;

      switch (action) {
        case 'view_ticket':
          if (payload?.ticket_id) {
            navigate(`/agents/tickets/${payload.ticket_id}`);
          }
          break;

        case 'answer':
          navigate('/agent/calls');
          window.dispatchEvent(new CustomEvent('answerCall', { detail: payload }));
          break;

        case 'decline':
          console.log('Appel refusé', payload);
          break;

        case 'dismiss':
          // Rien à faire, la notification est déjà fermée
          break;

        default:
          // Redirection par défaut
          if (payload?.url) {
            navigate(payload.url);
          }
      }
    };

    window.addEventListener('notificationAction', handleNotificationAction as EventListener);

    return () => {
      window.removeEventListener('notificationAction', handleNotificationAction as EventListener);
    };
  }, [navigate]);
}